import { Download } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgDownloadThickBottom = mkIcon(Download);